import { Link } from "react-router-dom";
import { ShoppingBag, BookOpen } from "lucide-react";
import { BOOKS } from "../lib/content";

export default function Books() {
  return (
    <div data-testid="books-page" className="bg-cream">
      <section className="container-vk pt-20 md:pt-28 pb-16">
        <p className="overline mb-6">The Library</p>
        <h1 className="heading-display text-5xl sm:text-6xl lg:text-7xl font-semibold leading-[1.02] tracking-tight max-w-5xl">
          Explore the{" "}
          <span className="italic text-burgundy">Catalogue</span>.
        </h1>
        <p className="mt-8 text-lg text-ink/70 max-w-3xl leading-relaxed">
          An expanding collection of books by Victor Kwawukume exploring
          identity, migration, resilience, memory, leadership, and the
          enduring human capacity for renewal.
        </p>
      </section>

      <section className="container-vk pb-32 space-y-28 md:space-y-36">
        {BOOKS.map((b, idx) => (
          <article
            key={b.slug}
            id={b.slug}
            data-testid={`book-detail-${b.slug}`}
            className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start scroll-mt-32"
          >
            <div className={`lg:col-span-5 ${idx % 2 ? "lg:order-2" : ""}`}>
              <div className="relative aspect-square overflow-hidden border border-paperline bg-cream-deep shadow-[0_30px_60px_-20px_rgba(26,26,26,0.18)]">
                <img
                  src={b.cover}
                  alt={`${b.title} — book cover`}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-contain"
                />
                <div className="absolute top-4 left-4 bg-cream/90 backdrop-blur px-3 py-1.5 text-xs uppercase tracking-[0.2em] text-burgundy font-semibold">
                  Forthcoming
                </div>
              </div>
            </div>

            <div className={`lg:col-span-7 ${idx % 2 ? "lg:order-1" : ""}`}>
              <p className="overline mb-3">Book No. 0{idx + 1}</p>
              <h2 className="heading-display text-4xl sm:text-5xl lg:text-6xl font-semibold leading-[1.02] text-balance">
                {b.title}
              </h2>
              <p className="mt-4 text-lg italic font-serif text-ink/70 max-w-2xl">
                {b.tagline}
              </p>
              <p className="mt-8 text-lg text-ink/80 leading-relaxed max-w-2xl">
                {b.description}
              </p>

              <blockquote className="mt-10 border-l-2 border-burgundy pl-6 max-w-2xl">
                <p className="heading-display text-2xl md:text-3xl italic text-ink leading-snug">
                  {b.pull}
                </p>
              </blockquote>

              <div className="mt-10 flex flex-wrap gap-4">
                <span
                  data-testid={`buy-button-${b.slug}`}
                  aria-disabled="true"
                  className="btn-primary opacity-70 cursor-not-allowed pointer-events-none select-none"
                >
                  <ShoppingBag size={18} /> Coming Soon
                </span>
                <Link
                  to="/contact"
                  data-testid={`request-event-${b.slug}`}
                  className="btn-secondary"
                >
                  <BookOpen size={18} /> Request a Reading
                </Link>
              </div>
            </div>
          </article>
        ))}
      </section>
    </div>
  );
}
